/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.addEventListener("DOMContentLoaded", (event) => {
var custom_interval = setInterval(function() {
  if (typeof bundlesBear != 'undefined'){
    bundlesBear.getDiscountInformation();
    console.log("found");
    custom_interval = clearInterval(custom_interval);
  }else{
 console.log("notfound");
  }
}, 200);

  var colorSwatchesSlider = document.querySelector('.ColorSwatchList--carousel');
  if (colorSwatchesSlider != null) {
    var flkty = new Flickity(colorSwatchesSlider, {
      cellAlign: 'left',
      contain: true,
      watchCSS: true,
      prevNextButtons: false,
      pageDots: false
    });
  }
});
